<!-- <mat-dialog-content>
    <h1 class="text-black text-2xl mb-4">Cambiar Contraseña</h1>
    <form class="space-y-4">
        <div class="flex flex-col">
            <label for="emailUserToChange" class="text-gray-700">Email del Usuario</label>
            <input id="emailUserToChange" matInput type="email" name="emailUserToChange"
                [(ngModel)]="newPasswordUser.email_user_to_change" placeholder="Ingrese el email del usuario"
                class="border border-gray-300 rounded-md px-3 py-2 focus:outline-none focus:border-blue-500">
        </div>
        <div class="flex flex-col">
            <label for="newPassword" class="text-gray-700">Nueva Contraseña</label>
            <input id="newPassword" matInput type="text" name="newPassword" [(ngModel)]="newPasswordUser.password"
                placeholder="Ingrese su nueva contraseña"
                class="border border-gray-300 rounded-md px-3 py-2 focus:outline-none focus:border-blue-500">
        </div>

    </form>
</mat-dialog-content>
<mat-dialog-actions class="justify-between">

    <button mat-raised-button class="bg-orange-400 hover:bg-orange-500 text-white font-bold py-2 px-4 mb-3 rounded"
        (click)="handleChangePassword(newPasswordUser)" [disabled]="!isFormValid()">Guardar Cambios</button>
    <button mat-button class="bg-red-400 hover:bg-red-500 text-white font-bold py-2 px-4 mb-3 ml-5 rounded"
        (click)="closeModal()">Cancelar</button>
</mat-dialog-actions> -->

<mat-dialog-content>
    <h1 class="text-black text-2xl mb-4">Cambiar Contraseña</h1>
    <form class="space-y-4">
        <div class="flex flex-col">
            <label for="emailUserToChange" class="text-gray-700">Email del Usuario</label>
            <input id="emailUserToChange" matInput type="email" name="emailUserToChange"
                [(ngModel)]="newPasswordUser.email_user_to_change"
                class="border border-gray-300 rounded-md px-3 py-2 focus:outline-none focus:border-blue-500" readonly>
        </div>
        <div class="flex flex-col">
            <label for="newPassword" class="text-gray-700">Nueva Contraseña</label>
            <input id="newPassword" matInput type="text" name="newPassword" [(ngModel)]="newPasswordUser.password"
                placeholder="Ingrese su nueva contraseña"
                class="border border-gray-300 rounded-md px-3 py-2 focus:outline-none focus:border-blue-500">
        </div>
    </form>
</mat-dialog-content>
<mat-dialog-actions class="justify-between">
    <button mat-raised-button class="bg-orange-400 hover:bg-orange-500 text-white font-bold py-2 px-4 mb-3 rounded"
        (click)="handleChangePassword(newPasswordUser)" [disabled]="!isFormValid()">Guardar Cambios</button>
    <button mat-button class="bg-red-400 hover:bg-red-500 text-white font-bold py-2 px-4 mb-3 ml-5 rounded"
        (click)="closeModal()">Cancelar</button>
</mat-dialog-actions>